import { useId, useState, useEffect } from "react";
import classNames from "classnames";
import InputMask from "@mona-health/react-input-mask";

export default function PhoneField({
  label,
  value,
  onChange,
  id,
  className,
  errors = [],
}) {
  const inputId = id || useId();

  if (typeof onChange !== "function")
    console.debug("A text field doesn't have an onChange callback");

  const [isValid, setIsValid] = useState(errors.length == 0);

  useEffect(() => {
    setIsValid(errors.length == 0);
  }, [errors]);

  const handleChange = (event) => {
    if (typeof onChange === "function")
      onChange(event.target.value);

    setIsValid(true);
  };

  return (
    <div className="inpt-grp">
      {label && (
        <label htmlFor={inputId} className="lbl">{label}</label>
      )}

      <InputMask
        id={inputId}
        mask="+7(999)999-99-99"
        className={className || classNames("inpt-text", { "inpt--error": !isValid })}
        onChange={handleChange}
        value={value}
        maskPlaceholder="_"
        alwaysShowMask={true}
      />

      {!isValid && errors.map((error, index) => (
        <label key={index} className="lbl lbl--error">{error}</label>
      ))}
    </div>
  );
}
